module.exports = __webpack_public_path__ + "543333b9ff937c4c37031e470e2ab1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/realisations/saladexpress/saladexpress_09.jpg
// module id = 3B1V
// module chunks = 0